<template>
  <div>
    <el-form :inline="true" class="demo-form-inline">
      <div v-for="(item, index) in revisionListData" :key="index">
        <el-form-item :label="languageText('Rev')">
          {{ index + 1 }}
        </el-form-item>
        <el-form-item :label="languageText('RevisionDate')">
          <el-date-picker
            v-model="item.revision_date"
            :placeholder="languageText('RevisionDate')" 
            :disabled="item.is_complete"
            format="MM/dd/yyyy"
            value-format="MM/dd/yyyy"
            type="date"
            style="width: 140px"
            @change="handleDateChange">
        </el-date-picker>
        </el-form-item>
        <el-form-item :label="languageText('RequestedBy')">
          <el-input
            v-model="item.requested_by"
            :disabled="optionButtonFlag(item)"
            :placeholder="languageText('RequestedBy')"
            @input="handleApprovedByChange"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="languageText('RevisedNotes')">
          <el-input
            v-model="item.items_revised"
            :disabled="optionButtonFlag(item)"
            :placeholder="languageText('RevisedNotes')"
            @input="handleApprovedByChange"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="languageText('EditedBy')">
          <el-input
            v-model="item.edited_by"
            :disabled="optionButtonFlag(item)"
            :placeholder="languageText('EditedBy')"
            @input="handleApprovedByChange"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="languageText('Reason')">
          <el-input
            v-model="item.reason"
            :disabled="optionButtonFlag(item)"
            :placeholder="languageText('Reason')"
            @input="handleApprovedByChange"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="languageText('ApprovedBy')">
          <el-input
            v-model="item.approved_by"
            :placeholder="languageText('ApprovedBy')"
            :disabled="item.is_complete"
            style="width: 140px"
            @input="handleApprovedByChange"
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 120px">
          <el-button
            type="text"
            @click="completeHandle(item)"
            v-if="showAddRecordsButton(index)"
            >{{ languageText("Add") }}</el-button
          >
          &nbsp;&nbsp;
          <el-button
            type="text"
            :disabled="setAddRowDisable(index) || getAuthShow()"
            v-if="showDeleteRecordsButton(item)"
            @click="deleteHandle(index)"
            >{{ $t("action.delete") }}</el-button
          >
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import base from "@/common/base.js";
export default {
  props: {
    pageStatus: String,
    revisionList: {
      type: Array,
      required: true,
    },
    language: String,
  },
  data() {
    return {
      revisionListData: []
    };
  },
  watch: {
    revisionList: {
      immediate: true,
      handler(newVal) {
        this.revisionListData = JSON.parse(JSON.stringify(newVal));
        // If revision list is empty, add a default revision entry
        if (!this.revisionListData || this.revisionListData.length === 0) {
          this.addDefaultRevision();
        }
        this.normalizeRevisionDates();
        this.updateLocalStorage();
      }
    },
  },
  created() {
    // 设置数组大于 1的情况下， is_complete都为 true
    if(this.revisionList && this.revisionList.length > 1){
      this.revisionList.forEach(item => item.is_complete = true);
      // console.info('this.revisionList:',this.revisionList)
    }
  },
  methods: {
    getAuthShow(){
      return base.getAuthShow();
    },
    setAddRowDisable() {
      // let pageStatus = localStorage.getItem("pageStatus");
      // return pageStatus === "Detail";
      return false;
    },
    addDefaultRevision() {
      const defaultRevision = {
        approved_by: "",
        edited_by: "",
        is_complete: false,
        reason: "",
        requested_by: "",
        items_revised: "",
        revision_date: "",
      };
      this.revisionListData = [defaultRevision];
    },
    showAddRecordsButton(index){
      // 在详情页隐藏添加按钮
      if (this.pageStatus === "Detail") {
        return false;
      }
      return index == this.revisionListData.length - 1;
    },
    normalizeRevisionDates() {
      this.revisionListData.forEach(item => {
        if (item.revision_date) {
          item.revision_date = this.standardizeDateFormat(item.revision_date);
        }
      });
    },
    showDeleteRecordsButton(item) {
      return !item.is_complete;
    },
    deleteHandle(index) {
      this.revisionListData.splice(index, 1);
      this.$emit('update:revisionList', this.revisionListData);
      this.updateLocalStorage();
    },
    standardizeDateFormat(dateStr) {
      if (!dateStr) return '';
      
      if (this.isValidDateFormat(dateStr, 'dd/MM/yyyy')) {
        return dateStr;
      }
      
      const formats = ['MM/dd/yyyy', 'yyyy-MM-dd', 'dd/MM/yyyy'];
      
      for (let format of formats) {
        try {
          const date = this.parseDate(dateStr, format);
          if (date && !isNaN(date.getTime())) {
            return this.formatDate(date, 'dd/MM/yyyy');
          }
        } catch (e) {
          continue;
        }
      }
      
      return dateStr;
    },
    
    parseDate(dateStr, format) {
      const parts = dateStr.split(/[/-]/);
      if (parts.length !== 3) return null;
      
      let day, month, year;
      
      switch (format) {
        case 'dd/MM/yyyy':
          [day, month, year] = parts;
          break;
        case 'MM/dd/yyyy':
          [month, day, year] = parts;
          break;
        case 'yyyy-MM-dd':
          [year, month, day] = parts;
          break;
        default:
          return null;
      }
      
      return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    },
    
    formatDate(date, format) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      
      switch (format) {
        case 'dd/MM/yyyy':
          return `${day}/${month}/${year}`;
        case 'MM/dd/yyyy':
          return `${month}/${day}/${year}`;
        default:
          return `${day}/${month}/${year}`;
      }
    },
    
    isValidDateFormat(dateStr, format) {
      const date = this.parseDate(dateStr, format);
      return date && !isNaN(date.getTime());
    },
    
    formatDisplayDate(dateStr) {
      if (!dateStr) return '';
      return this.standardizeDateFormat(dateStr);
    },
    
    handleDateChange() {
      this.$emit('update:revisionList', this.revisionListData);
      this.updateLocalStorage();
    },
    handleApprovedByChange() {
      this.$emit('update:revisionList', this.revisionListData);
      this.updateLocalStorage(); 
    },
    updateLocalStorage() {
      try {
        localStorage.setItem("revision_list", JSON.stringify(this.revisionListData));
      } catch (e) {
        console.error("无法将 revisionListData 存储到 localStorage:", e);
      }
    },
    showAddRecords() {
      return true;
    },
    languageText: function (key) {
      let mappingLanage = [
        {
          english: "Rev",
          chinese: "版本",
        },
        {
          english: "RevisionDate", 
          chinese: "修订日期",
        },
        {
          english: "RequestedBy",
          chinese: "申请人",
        },
        {
          english: "RevisedNotes",
          chinese: "修订说明",
        },
        {
          english: "EditedBy",
          chinese: "编辑者",
        },
        {
          english: "Reason",
          chinese: "修订原因",
        },
        {
          english: "ApprovedBy",
          chinese: "审核人",
        },
        {
          english: "Complete",
          chinese: "添加修订记录",
        },
        {
          english: "Add",
          chinese: "添加",
        },
      ];

      if (this.language == "CN") {
        let foundItem = mappingLanage.find((item) => item.english == key);
        if (foundItem) {
          return foundItem.chinese;
        } else {
          // 如果没有找到对应的中文翻译，返回英文原文
          return key;
        }
      }
      return key;
    },
    completeHandle() {
      let revision = {
        approved_by: "",
        edited_by: "",
        is_complete: false,
        reason: "",
        requested_by: "",
        items_revised: "",
        revision_date: "",
      };
      this.revisionListData.push(revision);
      console.info("revisionListData:", this.revisionListData);
      this.$emit('update:revisionList', this.revisionListData);
      this.updateLocalStorage();
    },
    optionButtonFlag(item) {
      return item.is_complete;
    },
  },
};
</script>